import React from 'react';

export const DetailedResultsSkeleton: React.FC = () => {
  return (
    <div className='w-full h-[calc(100vh-8rem)] overflow-y-auto animate-pulse'>
      <div className='p-4 pb-12'>
        { /* Candidate Info Card Skeleton */ }
        <div className='mb-4 bg-white/50 backdrop-blur-sm rounded-2xl px-4 py-3 border border-gray-200/60 shadow-sm'>
          <div className='flex items-center gap-3'>
            <div className='w-10 h-10 bg-gray-200 rounded-full'></div>
            <div className='space-y-2 flex-1'>
              <div className='h-4 bg-gray-200 rounded w-1/4'></div>
              <div className='h-3 bg-gray-100 rounded w-1/3'></div>
            </div>
            <div className='space-y-2 text-right'>
              <div className='h-3 bg-gray-200 rounded w-20'></div>
              <div className='h-2 bg-gray-100 rounded w-16 ml-auto'></div>
            </div>
          </div>
        </div>

        { /* Skills Assessment Header Skeleton */ }
        <div className='mb-6'>
          <div className='mb-3 px-3 py-2 bg-white/40 backdrop-blur-sm rounded-xl border border-gray-200/50'>
            <div className='flex items-center gap-2.5'>
              <div className='w-7 h-7 bg-blue-100 rounded-lg'></div>
              <div className='space-y-1.5 flex-1'>
                <div className='h-4 bg-gray-200 rounded w-32'></div>
                <div className='h-2.5 bg-gray-100 rounded w-16'></div>
              </div>
            </div>
          </div>

          { /* Skills Grid Skeleton */ }
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3'>
            { [1, 2, 3].map((i) => (
              <div
                  key={i}
                  className='bg-white rounded-xl border border-gray-200/60 p-3 h-32 flex flex-col justify-between'
              >
                <div className='space-y-2'>
                  <div className='h-4 bg-gray-200 rounded w-3/4'></div>
                  <div className='h-3 bg-gray-100 rounded w-1/2'></div>
                </div>
                <div className='pt-2 border-t border-gray-50 grid grid-cols-2 gap-2'>
                  <div className='h-2.5 bg-gray-100 rounded w-full'></div>
                  <div className='h-2.5 bg-gray-100 rounded w-full'></div>
                </div>
              </div>
            )) }
          </div>
        </div>

        { /* Behavioral Interview Header Skeleton */ }
        <div className='mb-6'>
          <div className='mb-3 px-3 py-2 bg-white/40 backdrop-blur-sm rounded-xl border border-gray-200/50'>
            <div className='flex items-center gap-2.5'>
              <div className='w-7 h-7 bg-green-100 rounded-lg'></div>
              <div className='space-y-1.5 flex-1'>
                <div className='h-4 bg-gray-200 rounded w-48'></div>
                <div className='h-2.5 bg-gray-100 rounded w-20'></div>
              </div>
            </div>
          </div>

          { /* BEI Grid Skeleton */ }
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3'>
            { [1, 2, 3].map((i) => (
              <div
                  key={i}
                  className='bg-white rounded-xl border border-gray-200/60 p-3 h-32 flex flex-col justify-between'
              >
                <div className='space-y-2'>
                  <div className='h-4 bg-gray-200 rounded w-3/4'></div>
                  <div className='h-3 bg-gray-100 rounded w-1/2'></div>
                </div>
                <div className='pt-2 border-t border-gray-50'>
                  <div className='h-2.5 bg-gray-100 rounded w-full'></div>
                </div>
              </div>
            )) }
          </div>
        </div>
      </div>
    </div>
  );
};
